const en: Record<string, string> = {
  // --- Common / Shared ---
  "common.loading": "Loading...",
  "common.save": "Save",
  "common.saving": "Saving...",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.create": "Create",
  "common.creating": "Creating...",
  "common.close": "Close",
  "common.copy": "Copy",
  "common.search": "Search...",
  "common.back": "Back",
  "common.next": "Next",
  "common.yes": "Yes",
  "common.no": "No",
  "common.active": "Active",
  "common.inactive": "Inactive",
  "common.on": "On",
  "common.off": "Off",
  "common.name": "Name",
  "common.email": "Email",
  "common.domain": "Domain",
  "common.slug": "Slug",
  "common.role": "Role",
  "common.status": "Status",
  "common.actions": "Actions",
  "common.settings": "Settings",
  "common.upload": "Upload",
  "common.uploading": "Uploading...",
  "common.download": "Download",
  "common.remove": "Remove",
  "common.add": "Add",
  "common.entries": "Entries",
  "common.entry": "Entry",
  "common.fields": "Fields",
  "common.preview": "Preview",
  "common.noLogo": "No logo",
  "common.noIcon": "No icon",
  "common.noImage": "No image",
  "common.networkError": "Network error",
  "common.connectionError": "Connection error. Server not reachable.",
  "common.errorOccurred": "An error occurred",
  "common.errorLoading": "Error loading",
  "common.errorSaving": "Error saving",
  "common.errorDeleting": "Error deleting",
  "common.errorUpdating": "Error updating",
  "common.errorCreating": "Error creating",
  "common.saved": "Saved",
  "common.justNow": "just now",
  "common.minutesAgo": "{n} min ago",
  "common.hoursAgo": "{n} h ago",
  "common.deleted": "Deleted",
  "common.admin": "Admin",
  "common.editor": "Editor",
  "common.password": "Password",
  "common.live": "Live",
  "common.draft": "Draft",
  "common.title": "Title",
  "common.all": "All",
  "common.main": "Main",
  "common.pleaseSelect": "Please select",
  "common.activate": "Activate",
  "common.deactivate": "Deactivate",
  "common.error": "Error",
  "common.date": "Date",
  "common.selected": "selected",
  "common.selectAll": "Select all",
  "common.deselectAll": "Deselect all",
  "common.noResults": "No results",
  "common.copied": "Copied",
  "common.rename": "Rename",
  "common.reset": "Reset",

  // --- Auth / Login ---
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.emailPlaceholder": "name@example.com",
  "auth.passwordPlaceholder": "Enter password",
  "auth.forgotPassword": "Forgot password?",
  "auth.login": "Sign in",
  "auth.loggingIn": "Signing in...",
  "auth.logout": "Sign out",
  "auth.loginError": "Email or password is incorrect",
  "auth.connectionError": "Connection error. Server not reachable.",

  // --- Forgot Password ---
  "forgot.title": "Forgot password",
  "forgot.description": "Enter your email. You will receive a link to reset your password.",
  "forgot.send": "Send link",
  "forgot.sending": "Sending...",
  "forgot.success": "Email sent",
  "forgot.successMsg": "If an account with this email exists, a reset link has been sent.",
  "forgot.backToLogin": "Back to login",
  "forgot.error": "An error occurred.",

  // --- Reset Password ---
  "reset.checking": "Checking link...",
  "reset.newPassword": "New password",
  "reset.confirmPassword": "Confirm password",
  "reset.minChars": "At least 12 characters",
  "reset.repeatPassword": "Repeat password",
  "reset.tooShort": "Password must be at least 12 characters long.",
  "reset.mismatch": "Passwords do not match.",
  "reset.charsNeeded": "{n} more characters needed",
  "reset.longEnough": "Password is long enough",
  "reset.passwordsMismatch": "Passwords do not match",
  "reset.submit": "Change password",
  "reset.submitting": "Changing...",
  "reset.masterError": "Not possible",
  "reset.invalidLink": "Invalid link",
  "reset.masterMsg": "The master password can only be changed in the server settings.",
  "reset.expiredMsg": "This link is invalid or has expired.",
  "reset.requestNew": "Request new link",
  "reset.success": "Password changed. You can now sign in.",
  "reset.backToLogin": "Back to login",

  // --- Admin Sidebar ---
  "adminSidebar.dashboard": "Dashboard",
  "adminSidebar.kunden": "Clients",
  "adminSidebar.newKunde": "New client",
  "adminSidebar.settings": "Settings",
  "adminSidebar.collapse": "Collapse",

  // --- Admin Dashboard ---
  "dashboard.title": "Dashboard",
  "dashboard.subtitle": "Overview of all clients",
  "dashboard.totalKunden": "Total clients",
  "dashboard.activeKunden": "Active clients",
  "dashboard.cmsEnabled": "CMS enabled",
  "dashboard.newKunde": "+ New client",
  "dashboard.recentChanges": "Recent changes",
  "dashboard.noChanges": "No changes available.",

  // --- Kunden List ---
  "kunden.title": "Clients",
  "kunden.newKunde": "New client",
  "kunden.newPassword": "New password:",
  "kunden.noResults": "No results.",
  "kunden.empty": "No clients available.",
  "kunden.modules": "Modules",
  "kunden.cms": "CMS",
  "kunden.statusUpdated": "Status updated",
  "kunden.resetPassword": "Reset password",
  "kunden.openCms": "Open CMS",
  "kunden.confirmDelete": "Really delete \"{name}\"?\nAll data ({pages} pages, {posts} posts, {media} media) will be permanently deleted.",
  "kunden.deleted": "Client deleted",

  // --- New Kunde ---
  "newKunde.title": "New client",
  "newKunde.sectionKunde": "Client",
  "newKunde.sectionUser": "First user",
  "newKunde.sectionOptional": "Optional settings",
  "newKunde.sectionModules": "Modules",
  "newKunde.namePlaceholder": "Hotel Example",
  "newKunde.slugPlaceholder": "hotel-example",
  "newKunde.domainPlaceholder": "www.hotel-example.com",
  "newKunde.contactEmail": "Contact email (optional)",
  "newKunde.contactPlaceholder": "info@hotel-example.com",
  "newKunde.loginEmail": "Login email *",
  "newKunde.loginEmailPlaceholder": "max@hotel-example.com",
  "newKunde.generate": "Generate",
  "newKunde.orKey": "OpenRouter Key (optional)",
  "newKunde.orModel": "OpenRouter Model (optional)",
  "newKunde.orModelPlaceholder": "e.g. anthropic/claude-sonnet-4",
  "newKunde.cmsActive": "Activate CMS immediately",
  "newKunde.sendEmail": "Send credentials via email",
  "newKunde.submit": "Create client",
  "newKunde.submitting": "Creating...",
  "newKunde.fillRequired": "Please fill in all required fields (Name, Slug, Domain).",
  "newKunde.fillUserRequired": "Please fill in all required user fields (Name, Email, Password).",
  "newKunde.created": "Client {name} created",
  "newKunde.emailSent": "Credentials sent via email",
  "newKunde.emailFailed": "Could not send email",

  // --- Kunde Detail (Tabs) ---
  "kundeDetail.pages": "Pages",
  "kundeDetail.posts": "Posts",
  "kundeDetail.media": "Media",
  "kundeDetail.aiGenerate": "AI Generate",
  "kundeDetail.tabGeneral": "General",
  "kundeDetail.tabDesign": "Design",
  "kundeDetail.tabSeo": "SEO & Marketing",
  "kundeDetail.tabLegal": "Legal & Cookie",
  "kundeDetail.tabContent": "Content",
  "kundeDetail.tabAccess": "Access",
  "kundeDetail.tabHistory": "History",
  "kundeDetail.changesSaved": "Changes saved",
  "kundeDetail.notFound": "Client not found",
  "kundeDetail.confirmDelete": "Really delete \"{name}\"?\nAll data ({pages} pages, {posts} posts, {media} media) will be permanently deleted.",
  "kundeDetail.deleted": "Client deleted",
  "kundeDetail.aiModalTitle": "Generate page with AI",
  "kundeDetail.aiPageName": "Page name",
  "kundeDetail.aiPageNamePlaceholder": "e.g. Home, About us, Contact",
  "kundeDetail.aiDescription": "Description *",
  "kundeDetail.aiDescPlaceholder": "Describe the page content. E.g.: A homepage for a hotel in South Tyrol with hero section, room overview as cards, and contact info.",
  "kundeDetail.aiStyle": "Style / Tone (optional)",
  "kundeDetail.aiStylePlaceholder": "e.g. professional, friendly, modern",
  "kundeDetail.aiGenerating": "Generating...",
  "kundeDetail.aiGenerateButton": "Generate",
  "kundeDetail.aiPageCreated": "Page \"{name}\" with {count} sections created",
  "kundeDetail.previewTitle": "Preview of generated text",
  "kundeDetail.textCopied": "Text copied",
  "kundeDetail.pagesCreated": "{count} page(s) created ({names})",
  "kundeDetail.alreadyExists": "{count} already existing",
  "kundeDetail.done": "Done",
  "kundeDetail.confirmDeleteOrKey": "Really delete OpenRouter Key?",
  "kundeDetail.confirmDeleteRedirect": "Really delete redirect?",
  "kundeDetail.legalGenerateError": "Error generating",

  // --- Kunde Detail: General Tab ---
  "general.contactEmail": "Contact email",
  "general.contactPlaceholder": "info@client.com",
  "general.orKey": "OpenRouter Key (optional)",
  "general.keyDeleted": "Key deleted",
  "general.keySaved": "Key saved",
  "general.newKeyOnSave": "New key will be set on save",
  "general.noKey": "No key",
  "general.orModel": "OpenRouter Model (optional)",
  "general.orModelPlaceholder": "e.g. anthropic/claude-sonnet-4",
  "general.cmsActive": "CMS active",
  "general.kundeActive": "Client active",
  "general.systemPrompt": "System Prompt",
  "general.systemPromptPlaceholder": "Custom system prompt for the client...",
  "general.languages": "Languages",
  "general.mainLanguage": "Main language",
  "general.mainBadge": "(main)",
  "general.availableLanguages": "Available languages",

  // --- Kunde Detail: Design Tab ---
  "design.branding": "Branding",
  "design.logo": "Logo",
  "design.uploadLogo": "Upload logo",
  "design.svgRecommended": "SVG recommended for best quality",
  "design.orEnterUrl": "or enter URL",
  "design.favicon": "Favicon",
  "design.uploadFavicon": "Upload favicon",
  "design.faviconFormats": "SVG, PNG or ICO",
  "design.colors": "Colors",
  "design.primaryColor": "Primary color",
  "design.secondaryColor": "Secondary color",
  "design.backgroundColor": "Background",
  "design.textColor": "Text color",
  "design.headingColor": "Headings",
  "design.footerBg": "Footer background",
  "design.typography": "Typography",
  "design.headings": "Headings",
  "design.textElements": "Text & Elements",
  "design.preview": "Preview",
  "design.fontFamily": "Font Family",
  "design.systemFont": "— System Font —",
  "design.customFont": "Custom Font (WOFF2/TTF/OTF)",
  "design.removeFont": "Remove font",
  "design.fontWeight": "Weight",
  "design.fontSize": "Size (rem)",
  "design.lineHeight": "Line Height",
  "design.fontColor": "Color",
  "design.textStyle": "Text Style",
  "design.letterSpacing": "Letter Spacing (em)",
  "design.normal": "Normal",
  "design.uppercase": "UPPERCASE",
  "design.lowercase": "lowercase",
  "design.capitalize": "Capitalize First Letter",
  "design.or": "or",
  "design.pasteUrl": "Paste URL",
  "design.removeLogo": "Remove logo",
  "design.removeFavicon": "Remove favicon",
  "design.uploaded": "Uploaded",
  "design.uploadFailed": "Upload failed",
  "design.fontUploaded": "Font \"{name}\" uploaded",
  "design.bodyLabel": "Body",
  "design.previewH1": "Main Heading",
  "design.previewH2": "Subheading",
  "design.previewH3": "Sub-subheading",
  "design.previewH4": "Small Heading",
  "design.previewBody": "This is a sample body text for the website.",
  "design.previewNav": "Home  About  Contact",
  "design.previewFooter": "© 2026 Company name. All rights reserved.",
  "design.previewButton": "Inquire now",

  // --- Kunde Detail: SEO Tab ---
  "seo.seoAnalytics": "SEO & Analytics",
  "seo.metaTitle": "Meta Title (default)",
  "seo.metaTitlePlaceholder": "e.g. Bergblick Apartments",
  "seo.titleSuffix": "Title Suffix",
  "seo.titleSuffixPlaceholder": "e.g. | Bergblick Apartments",
  "seo.previewLabel": "Preview:",
  "seo.pageName": "Page name",
  "seo.metaDescription": "Meta Description",
  "seo.metaDescPlaceholder": "Default description for search engines (150-160 characters optimal)",
  "seo.chars": "characters",
  "seo.metaKeywords": "Meta Keywords",
  "seo.metaKeywordsPlaceholder": "e.g. hotel, south tyrol, vacation",
  "seo.analyticsId": "Google Analytics ID",
  "seo.analyticsPlaceholder": "e.g. G-XXXXXXXXXX",
  "seo.tagManagerId": "Tag Manager ID",
  "seo.tagManagerPlaceholder": "e.g. GTM-XXXXXXX",
  "seo.tagManagerHint": "Google Tag Manager Container ID",
  "seo.noIndex": "Block website from search engines",
  "seo.noIndexHint": "Enables noindex/nofollow on all pages. Recommended for development/beta.",
  "seo.ogImage": "Default OG Image",
  "seo.ogImagePlaceholder": "https://... (1200×630px recommended)",
  "seo.ogImageHint": "Used when a page has no own OG image. Recommended: 1200×630px",
  "seo.branding": "Logo & favicon for search engines",
  "seo.brandingHint": "Dedicated files for Google & Co.: Schema.org logo (Knowledge Panel) and the icon next to the search result. Empty = logo/favicon from the “Design” tab. Useful when the website logo is white and disappears on a light background.",
  "seo.logo": "SEO logo",
  "seo.logoHint": "Dark artwork on a light or opaque background, min. 112×112px, PNG or SVG.",
  "seo.favicon": "SEO favicon",
  "seo.faviconHint": "Square, min. 48×48px (Google), PNG, SVG or ICO.",
  "seo.brandingFallbackActive": "The file from the “Design” tab is currently in use.",
  "seo.verification": "Search engine verification",
  "seo.googleVerification": "Google Verification Code",
  "seo.googleVerificationHint": "From Google Search Console → Settings → Ownership verification",
  "seo.bingVerification": "Bing Verification Code",
  "seo.bingVerificationHint": "From Bing Webmaster Tools",
  "seo.businessInfo": "Business Information (Schema.org)",
  "seo.businessType": "Business Type",
  "seo.openingHours": "Opening hours (structured for Schema.org)",
  "seo.openingHoursFormat": "Format: HH:MM-HH:MM (e.g. 08:00-18:00). Empty = closed on that day.",
  "seo.timeExample": "e.g. 08:00-18:00",
  "seo.closedHint": "empty = closed",
  "seo.socialMedia": "Social Media",
  "seo.socialHint": "Also used for Schema.org sameAs and footer links.",
  "seo.days.mo": "Mon",
  "seo.days.di": "Tue",
  "seo.days.mi": "Wed",
  "seo.days.do": "Thu",
  "seo.days.fr": "Fri",
  "seo.days.sa": "Sat",
  "seo.days.so": "Sun",

  // --- Kunde Detail: Legal Tab ---
  "legal.title": "Legal Notice",
  "legal.company": "Company",
  "legal.companyName": "Company name",
  "legal.companyNamePlaceholder": "e.g. Example Ltd",
  "legal.legalForm": "Legal form",
  "legal.noSelection": "— No selection —",
  "legal.vatId": "VAT ID",
  "legal.vatIdPlaceholder": "e.g. IT01234567890",
  "legal.taxCode": "Tax Code",
  "legal.taxCodePlaceholder": "e.g. 01234567890",
  "legal.tradeRegister": "Trade Register",
  "legal.tradeRegisterPlaceholder": "e.g. BZ-123456",
  "legal.reaNumber": "REA Number",
  "legal.address": "Address",
  "legal.street": "Street + No.",
  "legal.streetPlaceholder": "e.g. Example Street 1",
  "legal.zip": "ZIP",
  "legal.zipPlaceholder": "e.g. 39100",
  "legal.city": "City",
  "legal.cityPlaceholder": "e.g. Bolzano",
  "legal.province": "Province",
  "legal.provincePlaceholder": "e.g. BZ",
  "legal.country": "Country",
  "legal.countryPlaceholder": "e.g. IT",
  "legal.contact": "Contact",
  "legal.phone": "Phone",
  "legal.phonePlaceholder": "e.g. +39 0471 123456",
  "legal.emailImprint": "Email (legal notice)",
  "legal.emailPlaceholder": "e.g. info@company.com",
  "legal.pec": "PEC",
  "legal.pecPlaceholder": "e.g. company@pec.it",
  "legal.websiteUrl": "Website URL",
  "legal.websitePlaceholder": "e.g. https://www.company.com",
  "legal.responsible": "Responsible / Capital",
  "legal.owner": "Owner / Legal representative",
  "legal.ownerPlaceholder": "e.g. John Doe",
  "legal.capital": "Share capital",
  "legal.capitalPlaceholder": "e.g. 10,000.00 EUR",
  "legal.mediaSources": "Media content credits",
  "legal.mediaSourcesPlaceholder": "Photos: © John Doe / Shutterstock\nIcons: Lucide Icons (MIT License)\nVideos: © Company XY",
  "legal.mediaSourcesHint": "Sources for images, videos and other media content (one source per line)",
  "legal.imprintTexts": "Legal notice texts (optional)",
  "legal.imprintTextsHint": "Leave empty for automatic generation from the data above.",
  "legal.privacyTexts": "Privacy texts (optional)",
  "legal.privacyTextsHint": "Leave empty for automatic generation from client data.",
  "legal.cookieBanner": "Cookie Banner",
  "legal.cookieActive": "Cookie banner active",
  "legal.privacyUrl": "Privacy URL",
  "legal.privacyUrlPlaceholder": "e.g. /privacy or https://...",
  "legal.allDefaults": "Insert all default texts",
  "legal.generatePages": "Generate pages automatically",
  "legal.generatePagesDesc": "Automatically creates Legal Notice and Privacy pages from the entered data. Existing pages will **not** be overwritten.",
  "legal.generatePagesHint": "Please first enter company name, city and email.",
  "legal.generating": "Generating...",
  "legal.generateButton": "Create Legal Notice + Privacy pages",

  // --- Kunde Detail: Content Tab ---
  "content.openingHours": "Opening hours",
  "content.openingHoursLabel": "Opening hours (free text)",
  "content.openingHoursPlaceholder": "Mon-Fri: 08:00-18:00\nSat: 09:00-13:00\nSun: closed",
  "content.contactForm": "Contact form",
  "content.recipientEmail": "Recipient email",
  "content.recipientPlaceholder": "e.g. info@company.com",
  "content.defaultSubject": "Default subject",
  "content.subjectPlaceholder": "e.g. Website inquiry",
  "content.sendTestAnfrage": "Send test inquiry",
  "content.testAnfrageSent": "2 test emails sent to {email} ({sent})",
  "content.testAnfrageError": "Could not send test emails",
  "content.testAnfrageHint": "Sends 2 emails to the Super Admin address: notification (to operator) + confirmation (to sender). Uses the customer's logo and primary color.",
  "content.booking": "Booking / Reservation",
  "content.bookingUrl": "External booking URL",
  "content.bookingPlaceholder": "e.g. https://booking.com/hotel/...",
  "content.bookingHint": "e.g. Booking.com or own system",
  "content.footerText": "Footer text",
  "content.footerTextPlaceholder": "e.g. © 2026 Company Ltd. All rights reserved.",
  "content.footerTextHint": "Short text displayed in the website footer",
  "content.specialPages": "Special pages",
  "content.thankYouImage": "Thank you page image URL",
  "content.thankYouPlaceholder": "URL from media library",
  "content.thankYouHint": "Shown after form submission",
  "content.errorPageImage": "404 error page image URL",
  "content.errorPageHint": "Shown for pages not found",
  "content.modules": "Modules",
  "content.modulesManaged": "Modules are managed via their own configuration page.",
  "content.configureModules": "Configure modules",

  // --- Kunde Detail: Access Tab ---
  "access.permissions": "User permissions",
  "access.masterHint": "Master always has full access. Admin cannot have fewer permissions than editor.",
  "access.permission": "Permission",
  "access.savePermissions": "Save permissions",
  "access.editPages": "Edit pages",
  "access.createPages": "Create pages",
  "access.deletePages": "Delete pages",
  "access.editMeta": "Edit SEO/Meta",
  "access.uploadMedia": "Upload media",
  "access.deleteMedia": "Delete media",
  "access.editModules": "Edit modules",
  "access.createModules": "Create modules",
  "access.deleteModules": "Delete modules",
  "access.useChat": "Use chat",
  "access.manageUsers": "Manage users",
  "access.users": "Users",
  "access.newUser": "New user",
  "access.noUsers": "No users created yet.",
  "access.noUsersHint": "Create a user so the client can log in.",
  "access.lastLogin": "Last login",
  "access.editUser": "Edit user",
  "access.generatedPassword": "Generated password:",
  "access.sendCredentials": "Send credentials via email",
  "access.namePlaceholder": "John Doe",
  "access.emailPlaceholder": "john@example.com",
  "access.userCreated": "User created",
  "access.userUpdated": "User updated",
  "access.userDeleted": "User deleted",
  "access.newPasswordToast": "New password: {password}",
  "access.confirmDeleteUser": "Really delete \"{name}\"?",
  "access.deactivate": "Deactivate",
  "access.activate": "Activate",

  // --- Kunde Detail: History Tab ---
  "history.noChanges": "No changes available.",

  // --- Redirects ---
  "redirects.title": "Redirects",
  "redirects.new": "New redirect",
  "redirects.from": "From",
  "redirects.fromPlaceholder": "/old-path",
  "redirects.to": "To",
  "redirects.toPlaceholder": "/new-path or https://...",
  "redirects.type": "Type",
  "redirects.permanent": "301 (Permanent)",
  "redirects.temporary": "302 (Temporary)",
  "redirects.created": "Redirect created",
  "redirects.deleted": "Redirect deleted",
  "redirects.empty": "No redirects created yet.",
  "redirects.fromRequired": "From and To are required fields",
  "redirects.fromSlash": "From path must start with /",
  "redirects.toSlash": "To path must start with / or https://",
  "redirects.sameError": "From and To cannot be identical",
  "redirects.export": "Export links",
  "redirects.exportTitle": "Available links",
  "redirects.exportEmpty": "No links found.",
  "redirects.exportError": "Error loading links",
  "redirects.exportFilter": "Filter by URL or title...",
  "redirects.exportHint": "All current page URLs of the customer (incl. multilingual slugs).",
  "redirects.copyAll": "Copy all",
  "redirects.useAsTarget": "Use as target",
  "redirects.exportCsv": "CSV (Excel)",

  // --- Admin Settings ---
  "adminSettings.title": "Settings",
  "adminSettings.appearance": "Appearance",
  "adminSettings.logoHint": "Logo is displayed in the sidebar, login and emails. Recommended: PNG or SVG, transparent, max 400x120px.",
  "adminSettings.uploadLogo": "Upload logo",
  "adminSettings.svgBest": "SVG recommended for best quality",
  "adminSettings.loginBg": "Login background image",
  "adminSettings.loginBgHint": "Displayed on the login, forgot password and reset pages. Recommended: min 1920x1080px, JPG or WebP.",
  "adminSettings.uploadImage": "Upload image",
  "adminSettings.confirmRemoveLogo": "Really remove the logo?",
  "adminSettings.logoUploaded": "Logo uploaded",
  "adminSettings.logoRemoved": "Logo removed",
  "adminSettings.confirmRemoveBg": "Really remove the background image?",
  "adminSettings.bgUploaded": "Background image uploaded",
  "adminSettings.bgRemoved": "Background image removed",
  "adminSettings.onlyImageFormats": "Only PNG, JPG, SVG or WebP allowed",
  "adminSettings.fileTooLarge5": "File too large (max 5MB)",
  "adminSettings.onlyImageFormatsNoBg": "Only PNG, JPG or WebP allowed",
  "adminSettings.fileTooLarge10": "File too large (max 10MB)",
  "adminSettings.uploadFailed": "Upload failed",
  "adminSettings.removeFailed": "Error removing",
  "adminSettings.emailSystem": "Email System",
  "adminSettings.statusLabel": "Status:",
  "adminSettings.emailConnected": "Resend connected",
  "adminSettings.emailNotConfigured": "Not configured",
  "adminSettings.sender": "Sender",
  "adminSettings.alertEmail": "Alert email",
  "adminSettings.sendTest": "Send test email",
  "adminSettings.sendingTest": "Sending...",
  "adminSettings.testSent": "Test email sent to {email}",
  "adminSettings.testFailed": "Could not send email",
  "adminSettings.masterPassword": "Change master password",
  "adminSettings.currentPassword": "Current password",
  "adminSettings.newPassword": "New password",
  "adminSettings.minChars": "At least 8 characters",
  "adminSettings.fillBoth": "Please fill in both fields.",
  "adminSettings.passwordChanged": "Password changed successfully",
  "adminSettings.changePassword": "Change password",
  "adminSettings.serverInfo": "Server Information",
  "adminSettings.nodeJs": "Node.js",
  "adminSettings.platform": "Platform",
  "adminSettings.uptime": "Uptime",
  "adminSettings.environment": "Environment",
  "adminSettings.database": "Database",

  // --- Kunde Sidebar ---
  "kundeSidebar.overview": "Overview",
  "kundeSidebar.pages": "Pages",
  "kundeSidebar.blog": "Blog",
  "kundeSidebar.chat": "Chat",
  "kundeSidebar.users": "Users",
  "kundeSidebar.media": "Media",
  "kundeSidebar.settings": "Settings",
  "kundeSidebar.collapse": "Collapse",
  "kundeSidebar.openWebsite": "Open website",

  // --- Kunde Overview ---
  "overview.title": "Overview",
  "overview.welcome": "Welcome to the CMS",
  "overview.pages": "Pages",
  "overview.blogPosts": "Blog posts",
  "overview.media": "Media",
  "overview.quickAccess": "Quick access",
  "overview.editPages": "Edit pages",
  "overview.manageBlog": "Manage blog",
  "overview.uploadMedia": "Upload media",
  "overview.settings": "Settings",
  "overview.recentChanges": "Recent changes",
  "overview.settingsDesc": "Contact, password, SEO",
  "overview.modules": "Modules",
  "overview.chatDesc": "Edit content with AI",
  "overview.users": "Users",
  "overview.usersDesc": "Manage users",

  // --- Super Admin Banner ---
  "superAdmin.banner": "Super Admin View:",
  "superAdmin.backToAdmin": "Back to admin",
  "superAdmin.badge": "Super Admin",
  "superAdmin.switchKunde": "Switch client",
  "superAdmin.searchKunde": "Search client…",
  "superAdmin.noKunden": "No clients found",
  "superAdmin.loadError": "Clients could not be loaded",

  // --- Sidebar (shared) ---
  "sidebar.language": "Language",
  "sidebar.expand": "Expand",
  "sidebar.groupContent": "Content",
  "sidebar.groupAi": "AI",
  "sidebar.groupAdmin": "Administration",
  "sidebar.roleMaster": "Master",
  "sidebar.roleAdmin": "Admin",
  "sidebar.roleEditor": "Editor",

  // --- Kunde Layout Errors ---
  "kundeLayout.notAuthorized": "Not authorized. Please log in again.",
  "kundeLayout.loadError": "Error loading client data.",
  "kundeLayout.networkError": "Network error. Server not reachable.",
  "kundeLayout.genericError": "Could not load client data.",
  "kundeLayout.retry": "Retry",

  // --- Pages Editor ---
  "pages.title": "Pages",
  "pages.newPage": "New page",
  "pages.normal": "Content pages",
  "pages.landing": "Landing pages",
  "pages.all": "All pages",
  "pages.isLanding": "Landing page",
  "pages.isLandingDesc": "Not shown in the menu",
  "pages.normalPage": "Normal page",
  "pages.landingShort": "Landing",
  "pages.pageShort": "Page",
  "pages.filterLabel": "Show",
  "pages.import": "Import",
  "pages.export": "Export",
  "pages.searchPlaceholder": "Search pages…",
  "pages.clearSearch": "Clear search",
  "pages.noSearchResults": "No matching pages",
  "pages.collapse": "Collapse subpages",
  "pages.expand": "Expand subpages",
  "pages.viewLive": "View live",
  "pages.translationMissing": "{fehlend} of {gesamt} texts missing in {sprache}",
  "pages.translationMissingChildren": "incl. subpages",
  "pages.translationIncomplete": "incomplete",
  "pages.notInMenu": "Not in menu",
  "pages.saved": "Page saved",
  "pages.deleted": "Page deleted",
  "pages.created": "Page created",
  "pages.sectionCopied": "Section copied",
  "pages.sectionCopiedTo": "Section copied to \"{page}\"",
  "pages.duplicate": "Duplicate",
  "pages.duplicatePage": "Duplicate page",
  "pages.duplicated": "Page duplicated",
  "pages.copySuffix": "Copy",
  "pages.duplicateSource": "Copy of \"{page}\" including all sections, SEO data and translations.",
  "pages.duplicateShowInMenu": "Show copy in menu",
  "pages.duplicateShowInMenuDesc": "By default the copy stays hidden until it has been edited.",
  "pages.copySection": "Copy section",
  "pages.copyToOtherPage": "Copy to other page",
  "pages.copyError": "Error copying",
  "pages.uniqueIds": "Section IDs must be unique",
  "pages.invalidId": "Invalid section ID: \"{id}\"",
  "pages.invalidClass": "Invalid CSS class: \"{class}\"",
  "pages.parentPage": "Parent page",
  "pages.template": "Template",
  "pages.homepage": "Homepage",
  "pages.hidden": "hidden",
  "pages.sectionId": "ID / Anchor",
  "pages.cssClass": "CSS class",
  "pages.seo": "SEO",
  "pages.metaTitle": "Meta Title",
  "pages.metaDescription": "Meta Description",
  "pages.ogImage": "OG Image",
  "pages.socialMedia": "Social Media (Open Graph)",
  "pages.socialMediaDesc": "Title, description and image for shared links (WhatsApp, Facebook, LinkedIn). Empty = Meta Title / Meta Description are used.",
  "pages.ogTitle": "OG Title",
  "pages.ogTitlePlaceholder": "Title when sharing (empty = Meta Title)",
  "pages.ogDescription": "OG Description",
  "pages.ogDescPlaceholder": "Description when sharing (empty = Meta Description)",
  "pages.canonical": "Canonical",
  "pages.schema": "Schema",
  "pages.modulAsSubmenu": "Module as submenu",
  "pages.selectModule": "Select module",
  "pages.onThisPage": "On this page",
  "pages.addSection": "Add section",
  "pages.unnamedSection": "New section",
  "pages.addField": "Add field",
  "pages.advancedIdClass": "Advanced · ID & CSS class",
  "pages.addElement": "Add element",
  "pages.noElements": "No elements yet. Add the first one below.",
  "pages.elementPalette": "Choose element",
  "pages.noPageSelected": "Select a page from the list or create a new one.",
  "pages.fieldExists": "Field already exists",
  "pages.fieldDuplicated": "{field} duplicated",
  "pages.noTranslatableTexts": "No translatable texts found",
  "pages.chooseOtherLanguage": "Please choose a different target language",
  "pages.textsTranslated": "{count} texts translated",
  "pages.textsTranslatedPartial": "{count} texts translated, {missing} failed – please translate again",
  "pages.translationFailed": "Translation failed",
  "pages.confirmDeleteEntry": "Really delete entry?",
  "pages.hide": "Hide",
  "pages.show": "Show",
  "pages.idAndClass": "ID & Class",
  "pages.duplicateLabel": "Duplicate {label}",
  "pages.removeLabel": "Remove {label}",
  "pages.confirmDelete": "Really delete this page?",
  "pages.selectMultiple": "Select multiple pages",

  // --- Seiten: Versionsverlauf ---
  "versions.title": "Versions",
  "versions.open": "Show versions",
  "versions.empty": "No versions yet. They are created when you save.",
  "versions.current": "Current state",
  "versions.loadedBadge": "Loaded",
  "versions.view": "View",
  "versions.loadError": "Versions could not be loaded",
  "versions.loaded": "Version from {datum} loaded – not saved yet.",
  "versions.restore": "Restore",
  "versions.discard": "Discard",
  "versions.hint": "The last {n} versions of each page are kept.",
  "versions.source.ausgangsstand": "Initial state",
  "versions.source.speichern": "Saved",
  "versions.source.wiederherstellung": "Restored",
  "versions.source.ki": "AI",
  "versions.source.chat": "Chat",
  "versions.source.import": "Import",
  "versions.change.sectionChanged1": "1 section changed",
  "versions.change.sectionChangedN": "{n} sections changed",
  "versions.change.sectionAdded1": "1 section added",
  "versions.change.sectionAddedN": "{n} sections added",
  "versions.change.sectionRemoved1": "1 section removed",
  "versions.change.sectionRemovedN": "{n} sections removed",
  "versions.change.order": "Order",
  "versions.change.title": "Title",
  "versions.change.slug": "Slug",
  "versions.change.seo": "SEO",
  "versions.change.settings": "Settings",
  "versions.change.none": "No content change",
  "versions.detail.show": "Show details",
  "versions.detail.hide": "Hide details",
  "versions.detail.more": "+ {n} more changes",
  "versions.detail.empty": "empty",
  "versions.detail.bereich.seite": "Page",
  "versions.detail.bereich.seo": "SEO",
  "versions.detail.bereich.einstellungen": "Settings",
  "versions.detail.sectionAdded": "Section added",
  "versions.detail.sectionRemoved": "Section removed",
  "versions.detail.fieldAdded": "added",
  "versions.detail.fieldRemoved": "removed",
  "versions.detail.titel": "Title",
  "versions.detail.slug": "Slug",
  "versions.detail.name": "Name",
  "versions.detail.sichtbar": "Visible",
  "versions.detail.anker": "ID / anchor",
  "versions.detail.klasse": "CSS class",
  "versions.detail.feldReihenfolge": "Field order",
  "versions.detail.sektionReihenfolge": "Section order",
  "versions.detail.elternseite": "Parent page",
  "versions.detail.modulUntermenue": "Module as submenu",
  "versions.detail.menuVerhalten": "Menu behaviour",
  "versions.detail.menuNeuesTab": "Open in new tab",
  "versions.detail.menuUrl": "Menu URL",
  "versions.detail.landing": "Landing page",
  "versions.detail.nurSprachen": "Published in",

  "pages.unsavedChanges": "Unsaved changes",
  "pages.savedAgo": "Saved · {zeit}",
  "pages.translateShort": "Translate",
  "pages.new": "New",
  "pages.emptyPage": "Empty page",
  "pages.collapseChildren": "Collapse subpages",
  "pages.expandChildren": "Expand subpages",
  "pages.pageActions": "Page actions",
  "pages.selectAll": "Select all ({count})",
  "pages.selectAllResults": "Select all results ({count})",
  "pages.deleteSelected": "Delete {count}",
  "pages.confirmBulkDelete": "Really delete {count} pages?\nThis cannot be undone.",
  "pages.bulkDeleted": "{count} pages deleted",
  "pages.homepageNotDeletable": "The homepage cannot be deleted",
  "pages.autoTranslate": "Auto translate",
  "pages.sourceLanguage": "Source language",
  "pages.targetLanguage": "Target language",
  "pages.translate": "Translate",
  "pages.translating": "Translating...",
  "pages.deleteTranslation": "Delete translation",
  "pages.translationDeleted": "Translation deleted – save the page to apply changes",
  "pages.deleteTranslationWarning": "This action removes all translated content for the selected language on this page.",
  "pages.deleteTranslationConfirm": "I want to permanently delete the translation",
  "pages.fallbackHint": "Main language",
  "pages.clearFieldTranslation": "Clear translation for this field",
  "pages.fieldTranslationCleared": "Field translation cleared",
  "pages.removeFromMenu": "Remove from menu",
  "pages.showInMenu": "Show in menu",
  "pages.confirmDeleteSection": "Really delete this section?",
  "pages.noPages": "No pages available",
  "pages.selectPage": "Select page...",
  "pages.pageTitle": "Page title",
  "pages.sections": "Sections",
  "pages.noSections": "No sections available",
  "pages.selectSection": "Select a section",
  "pages.content": "Content",
  "pages.main": "Main",
  "pages.characters": "chars",
  "pages.metaTitlePlaceholder": "Page title for search engines",
  "pages.metaTitlePlaceholderLong": "Page title for search engines (empty = page title)",
  "pages.metaDescPlaceholder": "Short description for search results",
  "pages.schemaType": "Page type (Schema.org)",
  "pages.canonicalUrl": "Canonical URL (optional)",
  "pages.canonicalPlaceholder": "https://... (only set if page is duplicate)",
  "pages.ogImagePlaceholder": "https://... (1200×630px, empty = default OG image)",
  "pages.previewImage": "Preview image",
  "pages.modulAsSubmenuDesc": "Show module entries as sub-items in navigation",
  "pages.noParent": "None (top level)",
  "pages.childrenWillBecomeTopLevel": "Subpages of this page will be moved to the top level.",
  "pages.menuTitle": "Menu behavior",
  "pages.menuDesc": "How does this item behave in the main menu?",
  "pages.menuVerhaltenSeite": "Link to this page",
  "pages.menuVerhaltenSeiteDesc": "Default – opens the page",
  "pages.menuVerhaltenLabel": "Label only (no link)",
  "pages.menuVerhaltenLabelDesc": "Shown in the menu but not clickable",
  "pages.menuVerhaltenWeiterleitung": "Redirect",
  "pages.menuVerhaltenWeiterleitungDesc": "Redirects to a different URL (internal or external)",
  "pages.menuUrlLabel": "Target URL",
  "pages.menuUrlPlaceholder": "https://… or /path",
  "pages.menuUrlHelp": "Enter per language. Empty = falls back to main language.",
  "pages.menuNeuesTab": "Open in new tab",
  "pages.nurSprachenTitle": "Published in",
  "pages.nurSprachenDesc": "Languages in which the page appears on the website. Default: all.",
  "pages.nurSprachenHinweis": "Not published in: {sprachen}. Visits to these language versions are redirected to a published version; menu, sitemap and hreflang omit them.",
  "pages.nurSprachenMinEine": "At least one language must remain active",
  "pages.homepageDesc": "Main page without slug",
  "pages.slug": "Slug",
  "pages.slugAutoGenerated": "Automatically generated from the name",
  "pages.fieldName": "Field name",
  "pages.optionsComma": "Options (comma-separated)",
  "pages.customFields": "Custom fields",
  "pages.imagePosition": "Image position",
  "pages.spacing": "Spacing",
  "pages.entry": "Entry",
  "pages.module": "Module",
  "pages.layout": "Layout",
  "pages.layoutCards": "Cards",
  "pages.layoutList": "List",
  "pages.layoutSlider": "Slider",
  "pages.count": "Count",
  "pages.sorting": "Sorting",
  "pages.sortNewest": "Newest first",
  "pages.sortOrder": "Order",
  "pages.sortAlphabetical": "Alphabetical",
  "pages.titlePlaceholder": "e.g. Our References",
  "pages.translatableFieldsFound": "{count} translatable text fields found",
  "pages.inclPageTitle": "incl. page title",
  "pages.overwriteTranslations": "Overwrite existing translations",
  "pages.overwriteTranslationsHint": "Re-translate all fields, including already translated ones.",
  "pages.idTaken": "ID already taken",

  // --- Blog ---
  "blog.title": "Blog",
  "blog.newPost": "New post",
  "blog.empty": "No posts available.",
  "blog.confirmDelete": "Really delete this post?",
  "blog.deleted": "Post deleted",

  // --- Blog New ---
  "blogNew.title": "New post",
  "blogNew.titleLabel": "Title *",
  "blogNew.titlePlaceholder": "Post title",
  "blogNew.slugLabel": "Slug *",
  "blogNew.slugPlaceholder": "post-slug",
  "blogNew.excerptLabel": "Excerpt",
  "blogNew.excerptPlaceholder": "Short description...",
  "blogNew.contentLabel": "Content",
  "blogNew.contentPlaceholder": "Post content...",
  "blogNew.imageLabel": "Image URL",
  "blogNew.imagePlaceholder": "/uploads/...",
  "blogNew.published": "Published",
  "blogNew.draft": "Draft",
  "blogNew.required": "Title and slug required",
  "blogNew.created": "Post created",
  "blogNew.submit": "Create post",

  // --- Blog Edit ---
  "blogEdit.title": "Edit post",
  "blogEdit.notFound": "Post not found.",
  "blogEdit.published": "Post published",
  "blogEdit.saved": "Post saved",
  "blogEdit.deleted": "Post deleted",
  "blogEdit.confirmDelete": "Really delete this post?",
  "blogEdit.titleLabel": "Title",
  "blogEdit.slugLabel": "Slug",
  "blogEdit.excerptLabel": "Excerpt",
  "blogEdit.contentLabel": "Content",
  "blogEdit.imageLabel": "Image URL",

  // --- Module ---
  "module.title": "Modules",
  "module.newModule": "New module",
  "module.empty": "No modules",
  "module.emptyHint": "Create a new module for this client.",
  "module.detailPage": "Detail page",
  "module.categories": "Categories",
  "module.publication": "Publication",
  "module.expiry": "Expiry date",
  "module.configure": "Configure",
  "module.configureTitle": "Configure module",
  "module.newTitle": "New module",
  "module.nameLabel": "Name",
  "module.namePlaceholder": "e.g. Rooms",
  "module.keyLabel": "Key",
  "module.keyPlaceholder": "auto",
  "module.iconLabel": "Icon",
  "module.hasDetail": "Has detail page",
  "module.hasCategories": "Has categories",
  "module.hasPublication": "Publication date",
  "module.hasExpiry": "Expiry date",
  "module.unlimitedUpload": "Unlimited upload size",
  "module.loadTemplate": "Load template",
  "module.fieldCount": "Fields ({count})",
  "module.addField": "Field",
  "module.noFields": "No fields. Choose a template or add fields.",
  "module.nameKeyRequired": "Name and key required",
  "module.updated": "Module updated",
  "module.created": "Module created",
  "module.confirmDelete": "Really delete module \"{name}\"?\n{count} entries will also be deleted.",
  "module.deleted": "Module deleted",
  "module.fieldLabel": "Label",
  "module.fieldKey": "key",
  "module.fieldRequired": "Required",
  "module.fieldPlaceholder": "Placeholder (optional)",
  "module.fieldOptions": "Options (comma-separated)",
  "module.fieldMultiple": "Multiple",

  // --- Module Entries ---
  "moduleEntries.notFound": "Module not found",
  "moduleEntries.noEntries": "No entries",
  "moduleEntries.editEntry": "Edit entry",
  "moduleEntries.newEntry": "New entry",
  "moduleEntries.titleRequired": "Title required",
  "moduleEntries.updated": "Entry updated",
  "moduleEntries.created": "Entry created",
  "moduleEntries.deleted": "Entry deleted",
  "moduleEntries.categoryPlaceholder": "e.g. Standard, Premium",
  "moduleEntries.imageUrl": "Image URL",
  "moduleEntries.uploadFailed": "Upload failed",
  "moduleEntries.fileTooLarge": "File too large (max 20MB)",
  "moduleEntries.notConfigured": "This module has not been configured.",
  "moduleEntries.createFirst": "Create the first entry for {name}.",
  "moduleEntries.category": "Category",
  "moduleEntries.publication": "Publication",
  "moduleEntries.expiryDate": "Expiry date",
  "moduleEntries.scheduled": "Scheduled",
  "moduleEntries.expired": "Expired",
  "moduleEntries.confirmDelete": "Really delete \"{title}\"?",
  "moduleEntries.documentUrl": "Document URL",
  "moduleEntries.autoTranslate": "Auto translate",
  "moduleEntries.sourceLanguage": "Source language",
  "moduleEntries.targetLanguage": "Target language",
  "moduleEntries.translate": "Translate",
  "moduleEntries.translating": "Translating...",
  "moduleEntries.noTranslatableTexts": "No translatable texts found",
  "moduleEntries.chooseOtherLanguage": "Please choose a different target language",
  "moduleEntries.textsTranslated": "{count} texts translated",
  "moduleEntries.translationFailed": "Translation failed",
  "moduleEntries.translatableFieldsFound": "{count} translatable text fields found",

  // --- Media ---
  "media.title": "Media",
  "media.searchPlaceholder": "Search by name or alt text...",
  "media.onlyImages": "Only images allowed",
  "media.fileTooLarge": "File too large (max 20MB)",
  "media.uploaded": "Image uploaded",
  "media.uploadedMultiple": "Images uploaded",
  "media.deleted": "Image deleted",
  "media.saved": "Saved",
  "media.folderExists": "Folder already exists",
  "media.folderCreated": "Folder \"{name}\" created",
  "media.folderRenamed": "Folder renamed to \"{name}\"",
  "media.folderDeleted": "Folder \"{name}\" deleted",
  "media.confirmFolderDelete": "Delete folder \"{name}\"? {count} media will be moved to \"All\".",
  "media.confirmDelete": "Really delete?",
  "media.folderName": "Folder name",
  "media.all": "All",
  "media.noFolder": "No folder",
  "media.dropHere": "Drop images here",
  "media.newFolder": "New folder",
  "media.newSubfolder": "Subfolder",
  "media.deleteFolder": "Delete folder",
  "media.move": "Move",
  "media.moved": "{count} media moved",
  "media.noMediaInFolder": "No media in \"{folder}\"",
  "media.noMedia": "No media yet",
  "media.uploadToFolder": "Upload image to this folder",
  "media.uploadFirst": "Upload first image",
  "media.image": "Image",
  "media.filename": "Filename",
  "media.altText": "Alt text",
  "media.dimensions": "Dimensions",
  "media.size": "Size",
  "media.copyUrl": "Copy URL",
  "media.fullscreen": "Fullscreen",
  "media.editImage": "Edit image",
  "media.altTextSeo": "Alt text (SEO)",
  "media.altTextPlaceholder": "Description of the image for search engines...",
  "media.type": "Type",
  "media.original": "Original",
  "media.cropRotate": "Crop / Rotate",
  "media.editImageTitle": "Edit image",
  "media.rotate": "Rotate",
  "media.rotateLeft": "Rotate left",
  "media.rotateRight": "Rotate right",
  "media.aspect": "Aspect",
  "media.editHint": "Drag the corners to crop. On save all image variants are regenerated and optimized (max 600 KB).",
  "media.applyEdit": "Apply",
  "media.reoptimize": "Re-optimize",
  "media.reoptimizeHint": "Without cropping: regenerates all variants with the current settings and compresses the image.",
  "media.editSaved": "Image edited",
  "media.reprocessAll": "Re-optimize all",
  "media.reprocessAllHint": "Reprocesses all images with the current sizes/qualities and frees up storage.",
  "media.reprocessAllConfirm": "Re-optimize all images? Depending on the count this may take a few minutes.",
  "media.reprocessDone": "{done} images re-optimized",
  "media.reprocessDonePartial": "{done} re-optimized, {failed} failed",
  "media.reprocessFailed": "Re-optimization failed",
  "media.reprocessSelectedConfirm": "Re-optimize {count} selected images?",
  "media.noImagesSelected": "No images in selection",
  "media.replace": "Replace image",
  "media.replaceHint": "Replaces this image everywhere it is used (pages, modules, galleries). The address stays the same – no search/replace needed.",
  "media.replaceConfirm": "Replace this image everywhere with the new one? The new image will automatically appear on every page and in every module that uses it.",
  "media.replacing": "Replacing…",
  "media.replaced": "Image replaced – updated everywhere",
  "media.typeAll": "All",
  "media.typeImages": "Images",
  "media.typePdf": "PDF",
  "media.typeDocuments": "Documents",

  // --- Chat ---
  "chat.title": "Chat",
  "chat.empty": "Write a message to change content.",
  "chat.hint": "e.g. \"Change the hero title on the homepage\"",
  "chat.placeholder": "Write a message...",
  "chat.enterSend": "Enter = Send, Shift+Enter = New line",
  "chat.dropImage": "Drop image here",
  "chat.change": "{n} change",
  "chat.changes": "{n} changes made",
  "chat.mediaLibrary": "Media library",
  "chat.clickToInsert": "Click an image to insert it, or upload a new one.",
  "chat.noMedia": "No media available.",
  "chat.mediaLoadError": "Could not load media",
  "chat.imageUploaded": "Image uploaded",
  "chat.uploadFailed": "Upload failed. Please try again.",
  "chat.rateLimitError": "Rate limit reached",
  "chat.quickHero": "Change hero text",
  "chat.quickContact": "Update contact info",
  "chat.quickImage": "Replace image",

  // --- Users (Kunde) ---
  "users.title": "Users",
  "users.description": "Manage the users of your CMS.",
  "users.newUser": "New user",
  "users.empty": "No users created yet.",
  "users.namePlaceholder": "John Doe",
  "users.emailPlaceholder": "john@example.com",
  "users.noPermission": "No permission for user management",

  // --- Settings (Kunde) ---
  "kundeSettings.title": "Settings",
  "kundeSettings.contactData": "Contact data",
  "kundeSettings.changePassword": "Change password",
  "kundeSettings.seoPerPage": "SEO per page",
  "kundeSettings.newPasswordPlaceholder": "New password",
  "kundeSettings.minChars": "At least 6 characters",
  "kundeSettings.saved": "Settings saved",
  "kundeSettings.passwordChanged": "Password changed successfully",
  "kundeSettings.seoSaved": "SEO saved",
  "kundeSettings.change": "Change",
  "kundeSettings.language": "Language",

  // --- Language Switcher ---
  "lang.de": "Deutsch",
  "lang.it": "Italiano",
  "lang.en": "English",
  "lang.label": "Language",

  // --- Cookie Fields ---
  "cookie.titleDe": "Title German",
  "cookie.titleIt": "Title Italian",
  "cookie.titleEn": "Title English",
  "cookie.textDe": "Text German",
  "cookie.textIt": "Text Italian",
  "cookie.textEn": "Text English",
  "cookie.analyticsDe": "Analytics German",
  "cookie.analyticsIt": "Analytics Italian",
  "cookie.marketingDe": "Marketing German",
  "cookie.marketingIt": "Marketing Italian",
  "cookie.standard": "Default",

  // --- Custom Fields ---
  "fields.imageUploaded": "Image uploaded",
  "fields.uploadFailed": "Upload failed",
  "fields.mediaLoadFailed": "Failed to load media",
  "fields.noMedia": "No media available.",
  "fields.urlPlaceholder": "/uploads/... or enter URL",
  "fields.media": "Media",
  "fields.selectImage": "Select image",
  "fields.selectImages": "Select images",
  "fields.fromMediaLibrary": "From media library",
  "fields.moveForward": "Move forward",
  "fields.moveBackward": "Move backward",
  "fields.acceptImages": "Accept {count}",
  "fields.addButton": "Add button",
  "fields.addEntry": "Add entry",
  "fields.listFields": "Fields per entry",
  "fields.addCard": "Add card",
  "fields.addFaq": "Add FAQ",
  "fields.addLogo": "Add logo",
  "fields.entryN": "Entry {n}",
  "fields.logoN": "Logo {n}",
  "fields.yes": "Yes",
  "fields.no": "No",
  "fields.dateFrom": "From",
  "fields.dateTo": "To",
  "fields.pleaseSelect": "Please select...",
  "fields.bold": "Bold",
  "fields.italic": "Italic",
  "fields.bulletList": "Bullet list",
  "fields.numberedList": "Numbered list",
  "fields.link": "Link",
  "fields.removeLink": "Remove link",
  "fields.enterUrl": "Enter URL:",
  "fields.clickToRename": "Click to rename",
  "fields.duplicateField": "Duplicate field",
  "fields.removeField": "Remove field",
  "fields.videoPlaceholder": "https://youtube.com/watch?v=... or https://vimeo.com/...",
  "fields.style": "Style",
  "fields.buttonSize": "Size",
  "fields.small": "Small",
  "fields.medium": "Medium",
  "fields.large": "Large",
  "fields.iconLucide": "Icon (Lucide name)",
  "fields.optional": "(optional)",
  "fields.description": "Description",
  "fields.imageOptional": "Image (optional)",
  "fields.insertImage": "Insert image",
  "fields.companyName": "Company name",
  "fields.internalPage": "Internal page",
  "fields.externalUrl": "External URL",
  "fields.selectPage": "Select page...",
  "fields.searchPage": "Search page...",
  "fields.noPagesFound": "No pages found",

  // --- SEO Tool (Vorschau, Checkliste, KI, Redirects, Alt-Texte) ---
  "pages.serpPreview": "Google preview",
  "pages.serpDesktop": "Desktop",
  "pages.serpMobile": "Mobile",
  "pages.serpFallbackTitle": "Page title is used",
  "pages.serpFallbackDesc": "No meta description – Google will show an excerpt of the page.",
  "pages.socialPreview": "Share preview",
  "pages.socialNoImage": "No preview image",
  "pages.fokusKeyword": "Focus keyword",
  "pages.fokusKeywordPlaceholder": "e.g. holiday apartment Merano",
  "pages.fokusKeywordHint": "The search term this page should rank for. Checked in title, description, heading, URL and text.",
  "pages.seoChecklist": "SEO check",
  "pages.seoScore": "{ok} of {total} passed",
  "pages.pixelWidth": "{px} px",
  "pages.aiSuggest": "Suggest",
  "pages.aiSuggestTitleHint": "3 AI suggestions based on the page content",
  "pages.aiSuggestions": "AI suggestions",
  "pages.aiSuggestLoading": "Creating suggestions…",
  "pages.aiSuggestFailed": "Suggestion failed",
  "pages.aiSuggestNoText": "The page has no text yet. Please add content first.",
  "pages.apply": "Apply",
  "pages.noIndexTitle": "Do not index this page",
  "pages.noIndexHint": "Sets robots: noindex, nofollow for this page only. Useful for thank-you/test pages or content that should not appear on Google.",
  "pages.redirectTitle": "Create redirect?",
  "pages.redirectHint": "The URL of this page has changed. To keep old links and Google entries working, a 301 redirect should be created.",
  "pages.redirectCreate": "Create redirect",
  "pages.redirectSkip": "Not now",
  "pages.redirectCreated": "{n} redirect(s) created",
  "pages.redirectFailed": "Redirect could not be created",
  "seoCheck.titleMissing": "No meta title – the page title is used",
  "seoCheck.titleLong": "Meta title too long ({px} px) – Google will truncate it",
  "seoCheck.titleShort": "Meta title very short – add more context",
  "seoCheck.titleOk": "Meta title has a good length",
  "seoCheck.descMissing": "Meta description missing",
  "seoCheck.descLong": "Meta description too long ({n} characters)",
  "seoCheck.descShort": "Meta description very short ({n} characters)",
  "seoCheck.descOk": "Meta description has a good length",
  "seoCheck.h1Missing": "No heading (H1) – set a hero or section title",
  "seoCheck.h1Ok": "Heading (H1) present",
  "seoCheck.textThin": "Little text ({n} words) – at least 300 recommended",
  "seoCheck.textMedium": "{n} words – add more text for important pages",
  "seoCheck.textOk": "Sufficient text ({n} words)",
  "seoCheck.linksNone": "No internal links – link to other pages",
  "seoCheck.linksOk": "{n} internal links",
  "seoCheck.imagesNone": "No images on the page",
  "seoCheck.imagesCount": "{n} images on the page",
  "seoCheck.imagesAltMissing": "{n} of {total} images without alt text (media library)",
  "seoCheck.imagesOk": "All {n} images have alt text",
  "seoCheck.slugLong": "URL very long – choose a shorter slug",
  "seoCheck.keywordNone": "No focus keyword set",
  "seoCheck.keywordTitle": "Keyword in meta title",
  "seoCheck.keywordDesc": "Keyword in meta description",
  "seoCheck.keywordH1": "Keyword in heading",
  "seoCheck.keywordSlug": "Keyword in URL",
  "seoCheck.keywordIntro": "Keyword in the first paragraph",
  "seoCheck.keywordBodyNone": "Keyword does not appear in the text",
  "seoCheck.keywordStuffing": "Keyword used very often ({n}×) – looks unnatural",
  "seoCheck.keywordBody": "Keyword in text ({n}×)",
  "seoCheck.noIndex": "Page is excluded from indexing",
  "media.altGenerate": "Suggest with AI",
  "media.altGenerating": "Creating…",
  "media.altGenerated": "Alt text suggested",
  "media.altGenerateFailed": "Alt text could not be created",
  "media.altGenerateAll": "Missing alt texts via AI",
  "media.altGenerateAllConfirm": "Describe {n} images without alt text using AI? This may take a few minutes.",
  "media.altGenerateDone": "{done} alt texts created",
  "media.altGenerateDonePartial": "{done} alt texts created, {failed} failed",
  "media.altGenerateNone": "All images already have alt text",
  "media.altFilterMissing": "Without alt text",
};

export default en;
